/* CloudCompatModal.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import Button from '@atlaskit/button/standard-button';
import Modal, { ModalFooter, ModalTransition } from '@atlaskit/modal-dialog';
import { ExternalLink } from '@atlassian/mpac-ui';
import React from 'react';
import { ANALYTICS_EVENT_SOURCE_CONTACT_PARTNER_CLOUD } from '../../../analytics/Events';
import CloudGraphicSVG from './cloud-graphic.svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const cloudHeroStyles = null;
const heroImgOffset = 55;
const cloudHeroImgStyles = null;
const h3Styles = null;
const pStyles = null;
const modalContentStyles = null;
const cloudDescriptionContentStyles = null;
const customModalBodyStyles = null;
export default function CloudCompatModal(props) {
  return /*#__PURE__*/_jsx(ModalTransition, {
    children: props.isOpen && /*#__PURE__*/_jsxs(Modal, {
      onClose: props.onClose,
      children: [/*#__PURE__*/_jsxs("div", {
        className: customModalBodyStyles,
        children: [/*#__PURE__*/_jsx("div", {
          className: cloudHeroStyles,
          children: /*#__PURE__*/_jsx("img", {
            alt: "cloud computing icon",
            src: CloudGraphicSVG,
            className: cloudHeroImgStyles
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: modalContentStyles,
          children: [/*#__PURE__*/_jsx("h3", {
            className: h3Styles,
            children: "Cloud availability"
          }), /*#__PURE__*/_jsx("p", {
            className: cloudDescriptionContentStyles,
            children: "A cloud version of this app is currently not available."
          }), /*#__PURE__*/_jsxs("p", {
            className: pStyles,
            children: [props.partnerSupportUrl ? /*#__PURE__*/_jsx(ExternalLink, {
              href: props.partnerSupportUrl,
              onClick: () => {
                var _props$onContactPartn;
                return (_props$onContactPartn = props.onContactPartnerClick) === null || _props$onContactPartn === void 0 ? void 0 : _props$onContactPartn.call(props, ANALYTICS_EVENT_SOURCE_CONTACT_PARTNER_CLOUD);
              },
              children: "Contact the vendor"
            }) : 'Contact the vendor', ' ', "to let them know that you are interested to try this app for cloud."]
          })]
        })]
      }), /*#__PURE__*/_jsx(ModalFooter, {
        children: /*#__PURE__*/_jsx(Button, {
          appearance: "primary",
          onClick: props.onClose,
          children: "Dismiss"
        })
      })]
    })
  });
}